import { FormData } from '../types';

const WEBHOOKS = {
  default: 'https://hook.eu2.make.com/6nupvd2o5ntnej3perct57xxdaz6pvek',
  guide: 'https://hook.eu2.make.com/foe6bthlib8u2dry8xdm1v92gjtx6nyo'
};

export async function sendWebhook(data: FormData) {
  try {
    const webhookUrl = data.type === 'guide' ? WEBHOOKS.guide : WEBHOOKS.default;

    if (!webhookUrl) {
      throw new Error('Invalid webhook type');
    }

    // Ensure source is always included and properly formatted
    const source = data.source?.replace('_page', '') || 'unknown';
    const pagePath = window.location.pathname;

    // Only send essential form data
    const formData = {
      type: data.type,
      timestamp: data.timestamp || new Date().toISOString(),
      email: data.email,
      name: data.name,
      company: data.company,
      message: data.message,
      service: data.service,
      budget: data.budget,
      website: data.website,
      guide: data.guide,
      source: source,
      page: pagePath,
      referrer: document.referrer || 'direct'
    };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    try {
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`Webhook failed with status ${response.status}`);
      }

      return true;
    } catch (fetchError) {
      if (fetchError.name === 'AbortError') {
        throw new Error('Request timeout');
      }
      throw fetchError;
    }
  } catch (error) {
    console.error('Webhook error:', error instanceof Error ? error.message : 'Unknown error');
    return false;
  }
}